{
  "heading": "Campanion Admin — Privacy Policy",
  "intro": "This privacy policy applies to Campanion Admin, the camp administration web application provided by Campminder. It describes how Campminder collects, uses, and shares information in connection with your use of Campanion Admin.",
  "iframeTitle": "Campanion Admin Privacy Policy"
}
